import { render, staticRenderFns } from "./CorretoraSelecao.vue?vue&type=template&id=d53fcc68&scoped=true"
import script from "./CorretoraSelecao.vue?vue&type=script&lang=js"
export * from "./CorretoraSelecao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53fcc68",
  null
  
)

export default component.exports